import { createSearchParams, matchPath } from "react-router-dom";
import { buildPath } from "./helpers";

export const RegexpPatterns = {
  email:
    /^((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))?$/, //NOSONAR
};

//Project Specific

export const DEFAULT_LANGUAGE = "fr";
export const DEFAULT_COUNTRY = "FR";
export const DEFAULT_NETWORK = "fr";
export const SERVER_DATE_FORMAT = "YYYY-MM-DD";
export const SERVER_DATE_TIME_FORMAT = "YYYY-MM-DD[T]HH:mm:ss";
export const DEFAULT_TIME_FORMAT = "HH:mm:ss";

export const REQUIRED_CHAR = "!";

export const STORAGE_KEYS = {
  Language: "LANGUAGE",
  Mode: "MODE",
};

export const APP_URL = {
  Base: buildPath("/", ":network"),
  //Login: "login",
  //Logout: "logout",
  Loggedin: "/loggedin",
  Template: "template",
  FactoryStructure: "factory-structure",
  //CGU: "cgu",
  //FAQ: "FAQ",
  Help: "help",
  FAQ: "help/faq",
  CGU: "help/cgu",
  Changelog: "help/changelog",
  Satisfaction: "satisfaction",
  //Profile: "my_account",
  Account: "my_account",
  Clients: "clients",
  Heating: "chauffage",
  Etude: "etude/:etudeType/:etudeId",
  MyProjects: "my_projects",
  Solutions: "solutions",
  SolutionDetails: "solutions/:selectedDetail",
  SolutionDetailAccesories: "solutions/:selectedDetail/accessoires",
  SolutionDetailDocuments: "documents",
  Project: "project/:step/:mode",
  ProjectStep: "project/:step",
  LoadProject: "load_project/:id/:uid?",
  CompareProducts: "compareProducts",
};

export type Entities =
  | "product"
  | "step"
  | "workInstruction"
  | "operation"
  | "sequence"
  | "instructionFile"
  | "checklist"
  | "component"
  | "printingFunction"
  | "qualityFile"
  | "controlFile";

export const getAppUrl = (
  url?: string,
  options?: {
    searchParams?: Record<string, string>;
    network?: string;
  }
) => {
  if (url === undefined) {
    const match = matchPath(
      { path: APP_URL.Base, end: false },
      window.location.pathname
    );
    const path = window.location.pathname.replace(
      match?.pathname as string,
      ""
    );
    return path;
  }

  const { searchParams, network } = options ?? {};

  let result = buildPath(APP_URL.Base, url);

  if (searchParams) {
    const sp = createSearchParams(searchParams).toString();
    result = `${result}?${sp}`;
  }

  const pattern = matchPath(
    { path: APP_URL.Base, end: false },
    window.location.pathname
  );

  if (network) {
    return result.replace(":network", network);
  } else if (pattern?.params.network) {
    return result.replace(":network", pattern?.params.network);
  }

  return result.replace(":network", DEFAULT_NETWORK);
};


